module.exports = __webpack_public_path__ + "static/media/lupini.98362565.svg";